import { faMegaphone } from "@fortawesome/duotone-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import * as Sentry from "@sentry/react";
import { FC, useEffect, useRef, useState } from "react";

const ToggleFeedbackButton: FC = () => {
    const theme = useTheme();
    // The Sentry feedback integration instance (added in Sentry.init).
    const [feedback] = useState(() => Sentry.getFeedback());
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (buttonRef.current) {
            // Attach the feedback form to the button so that clicking it
            // opens the "Report a Bug" dialog.
            const unsubscribe = feedback?.attachTo(buttonRef.current, {
                colorScheme: theme.palette.mode === 'dark' ? 'dark' : 'light',
            });
            return () => {
                unsubscribe?.();
            };
        }
    }, [feedback, theme.palette.mode]);

    return (
        <Tooltip title="Report a Bug">
            <IconButton
                aria-label="report a bug"
                color="inherit"
                ref={buttonRef}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
};

export default ToggleFeedbackButton;
